import React from 'react'
import { Box, Typography } from 'components'
import { Switch, FormControlLabel } from '@material-ui/core'

export function UnionStatusSwitch({ filterState: state, setFilterState: setState }) {
  const { union_status } = state
  
  const handleChange = (event) => {
    // Set union_status as a boolean
    setState({ ...state, union_status: event.target.checked })
  }
  
  return (
    <Box py={1.5} flex={1} flexVariant="space-between align-center" minHeight="fit-content">
      <Box display="flex" alignItems="center" flex={1} flexDirection="column">
        <Box display="flex" alignItems="center" width="100%" justifyContent="space-between">
          <Typography variant="subtitle1">Non-Union</Typography>
          <FormControlLabel
            control={
              <Switch
                checked={!!union_status}
                onChange={handleChange}
                name="union_status"
                color="primary"
              />
            }
            label=""
          />
          <Typography variant="subtitle1">Union</Typography>
        </Box>
      </Box>
    </Box>
  )
}
